import ObjectID from "bson-objectid";
import {isValidLanguage} from "../../basic";
import {LANGUAGE_EXCEPTION} from "../../exceptions";
import DataController from "../DataController";

export interface ILanguage extends DataController {
    getIdentifier(): ObjectID;
    getDescriptor(): string;
    setDescriptor(descriptor: string): void;
    getDescription(): string;
    setDescription(description: string): void;
}

export default class Language extends DataController implements ILanguage {

    @DataController.dataProperty((x) => x.toString())
    public id: ObjectID;

    @DataController.dataProperty()
    public descriptor: string | undefined;

    @DataController.dataProperty()
    public description: string | undefined;

    constructor(identifier: ObjectID, descriptor?: any, description?: any) {
        super();
        this.id = new ObjectID(identifier.toString());
        this.descriptor = descriptor;
        this.description = description;
    }

    public getIdentifier(): ObjectID {
        return this.id;
    }

    public setIdentifier(id: ObjectID): void {
        this.id = id;
    }

    public getDescriptor() {
        return this.descriptor;
    }

    public setDescriptor(descriptor: string) {
        if(!isValidLanguage(descriptor)) {
            throw LANGUAGE_EXCEPTION;
        }
        this.descriptor = descriptor;
    }

    public getDescription() {
        return this.description;
    }

    public setDescription(description: string) {
        // TODO: check description?
        this.description = description;
    }

    public clone(): Language {
        return new Language(
            this.getIdentifier(),
            this.getDescriptor(),
            this.getDescription(),
        );
    }

}
